import {
  NotImplementedError,
  type DirectoryBooking,
  type Response,
} from './CRM';

export class GenericPlatform {
  platform: string = 'generic';

  async recordDirectoryBooking(details: DirectoryBooking): Promise<Response> {
    return {
      success: false,
      error: new NotImplementedError('recordDirectoryBooking', this.platform),
    };
  }
}

export type Platform = InstanceType<typeof GenericPlatform>;

// only method names (exclude properties like "platform")
type MethodNames<T> = {
  [K in keyof T]: T[K] extends (...args: any[]) => any ? K : never;
}[keyof T];

// map of method name -> method signature
export type GenericPlatformMethodMap = {
  [K in MethodNames<Platform>]: Platform[K];
};

// still export the union if you need it
export type GenericPlatformMethod = keyof GenericPlatformMethodMap;

// map of method name -> first argument type (or never)
export type MethodToFirstArgMap = {
  [K in keyof GenericPlatformMethodMap]: Parameters<
    NonNullable<GenericPlatformMethodMap[K]>
  > extends [infer P, ...any[]]
    ? P
    : never;
};

// optional: map of method name -> return type
export type MethodReturnMap = {
  [K in keyof GenericPlatformMethodMap]: GenericPlatformMethodMap[K] extends (
    ...args: any[]
  ) => infer R
    ? R
    : never;
};
